import AbstractCommand from "../../../core/application/AbstractCommand";
import SmartphoneSkinKeyRegistry from "../model/SmartphoneSkinKeyRegistry";
import SmartphoneDestroyEvent from "../model/SmartphoneDestroyEvent";

export default class SmartphoneSetupCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        this._smartphoneSkin = this.openPopup(SmartphoneSkinKeyRegistry.SMARTPHONE, null, { priority: 1, needsOverlay: false });

        this._destroySmartphoneBound = this._destroySmartphone.bind(this);
        this._dispatcher.addEventListener(SmartphoneDestroyEvent.PERFORM, this._destroySmartphoneBound);
    }

    destroy() {
        this._dispatcher.removeEventListener(SmartphoneDestroyEvent.PERFORM, this._destroySmartphoneBound);
    }

    _destroySmartphone() {
        this.closePopup(this._smartphoneSkin);

        this.destroy();
    }
}